import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { RocketIcon } from 'lucide-react';
export function OfferBanner() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const handleClick = () => {
    const el = document.getElementById('pricing');
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <AnimatePresence data-id="element-161">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 28
    }} className="fixed bottom-0 left-0 right-0 z-40 bg-[#0a0a14]/95 backdrop-blur-md border-t border-brand-orange/40 shadow-[0_-8px_30px_rgba(249,115,22,0.25)]" data-id="element-162">
          <div className="max-w-3xl mx-auto px-4 py-3 sm:py-4 flex items-center justify-between gap-3" data-id="element-163">
            <div className="flex flex-col leading-tight" data-id="element-164">
              <span className="text-[10px] sm:text-xs font-black uppercase tracking-widest text-brand-cream/80" data-id="element-165">
                Sistema Integrato Italiano™
              </span>
              <span className="text-2xl sm:text-3xl font-black text-brand-orange" data-id="element-166">
                €19,90
              </span>
            </div>
            <button onClick={handleClick} className="flex-1 max-w-[60%] sm:max-w-none inline-flex items-center justify-center gap-2 bg-gradient-to-r from-brand-orange to-brand-amber text-white font-black uppercase text-sm sm:text-base px-4 sm:px-6 py-3 sm:py-4 rounded-xl shadow-[0_0_20px_rgba(249,115,22,0.5)] hover:scale-[1.02] transition-transform" data-id="element-167">
              <RocketIcon className="w-5 h-5 shrink-0" data-id="element-168" />
              <span className="truncate" data-id="element-169">
                SÌ! VOGLIO RECUPERARE IL MIO TEMPO
              </span>
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}